import invoiceActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../util/createReducer';
import { combineReducers } from 'redux';
import moment from 'moment';

const INITIAL_STATE = {
  items: [],
};

export const reducers = {
  query: createAsyncRequestReducer(invoiceActionTypes.FETCH_INVOICES),
  getDownloadUrl: createAsyncRequestReducer(
    invoiceActionTypes.FETCH_INVOICE_DOWNLOAD_URL,
  ),
  invoices: createReducer(INITIAL_STATE, {
    [invoiceActionTypes.FETCH_INVOICES_SUCCESS]: (_: any, action: any) => ({
      items: (action?.response?.items || []).map((invoice: any) => {
        invoice.title = moment.utc(invoice.endTimestamp).format('LL');
        return invoice;
      }),
    }),
    [invoiceActionTypes.ADD_DOWNLOAD_URL_FOR_INVOICE]: (
      state: any,
      action: any,
    ) => ({
      items: state.items.map((invoice: any) => {
        return invoice.id === action.invoiceId
          ? { ...invoice, downloadUrl: action.downloadUrl }
          : invoice;
      }),
    }),
  }),
};

export default combineReducers(reducers);
